<template>
  <div class="about">
    <div><p style="text-align: right;">{{shop}}</p></div>
    <h1>Manual Inventory Group</h1>
    <section>
      <p><strong>A Manual Inventory Group</strong> includes the specific products or variants that you choose. The group will always contain the same products or variants unless you add or remove them.</p>
    </section>
    <v-alert style="margin-bottom: 10px" :value="true" color="info" icon="info" outline>
      Need a bit of help?  Contact us: <a href="mailto:support@inscoder.com">support@inscoder.com</a>
    </v-alert>
    <hr v-if="!loading">
    <v-layout v-if="loading" align-center justify-center row fill-height>
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-layout>

    <section v-if="!loading && mode=='groups-listing'">
      <v-layout v-if="manualgroup" align-center justify-space-between row>
        <p>This feature is currently turned on. Click the "<strong>Disable</strong>" button to stop using it.</p>
        <p><v-btn large color="primary" v-on:click="disableModeEnabled = true">Delete All</v-btn></p>
      </v-layout>
      <v-layout v-else align-center justify-space-between row>
        <p>This feature is currently turned off. Click the "<strong>Enable</strong>" button to begin using it.</p>
        <p><v-btn large color="primary" v-on:click="enableManualgroup">Enable</v-btn></p>
      </v-layout>
    </section>

    <section v-if="!loading && manualgroup && mode=='groups-listing'">
      <v-layout v-if="scanning" align-center justify-center row fill-height>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>

      <v-btn v-if="!scanning" style="text-transform: none" block large color="primary" @click="() => { this.mode = 'group-creating'; initNewGroup(); searchProducts(true, true) }"><v-icon small>add</v-icon> Create a new Manual Group</v-btn>

      <v-card v-if="!errored && !scanning">
        <v-card-title>
          <b>Groups</b>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="sku_groups"
          :pagination.sync="pagination"
          class="elevation-1"
          :rows-per-page-items='[500,1000,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]'
          :search="search"
        >
          <template v-slot:items="props">
            <td>{{ props.item.name }}</td>
            <td class="text-xs-right">
              <a @click="() => { editGroup(props.item.gid.domain, props.item.gid.id) }" style="margin-right: 20px">Edit Group | Inventory</a>
              <a @click="() => { openDeleteGroupDialog(props.item.gid.id) }">Delete</a>
            </td>
          </template>
        </v-data-table>
      </v-card>

    </section>

    <section v-if="mode=='group-creating'">
      <v-layout align-center justify-space-between row>
        <h2>Edit Group</h2>
        <p>
          <v-btn v-if="current_group_id!=0" large color="link" @click="() => {openLink(groupViewEditUrl)}" :disabled="savingGroup">Edit Inventory</v-btn>
          <v-btn v-if="current_group_id!=0" large color="link" @click="() => {openDeleteGroupDialog(this.current_group_id)}" :disabled="savingGroup">Delete Group</v-btn>
          <v-btn large color="primary" v-on:click="closeGroupView">Back to groups</v-btn>
        </p>
      </v-layout>

      <v-layout v-if="manualgroup" align-center justify-space-around row>
        <v-text-field
          label="Group Name"
          v-model="group_name"
          placeholder="Enter a Group Name (for example: Base T-Shirt White)"
          single-line
          solo
        >
        </v-text-field>
        <!--v-btn v-if="group_name == ''" style="top:-14px" disabled large color="primary">Save</v-btn-->
        <v-btn style="top:-14px" large color="primary" :disabled="savingGroup" v-on:click="saveGroup">Save</v-btn>
      </v-layout>

      <v-layout v-if="manualgroup" align-top justify-space-around row>
        <v-card style="width: 30%">
          <div style="padding: 20px">
            <v-text-field
              v-model="pKeyword"
              label="Search Products"
              placeholder="Type the product title to search"
            ></v-text-field>
            <v-layout v-if="searching" align-center justify-center row fill-height>
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-layout>
          </div>

          <v-expansion-panel v-if="!searching" style="box-shadow: none">
            <v-expansion-panel-content
              class="searched-product"
              v-for="(item,i) in searchedProducts"
              :key="i"
            >
              <div class="searched-product-title" slot="header">
                <img v-if="item.image" :src="item.image.src"><img v-if="!item.image" src="../assets/noimage.jpg"><strong>{{item.title}}</strong>
              </div>
              <div class="searched-product-variants">
                <v-layout class="variant" v-for="(v,j) in item.variants" align-center justify-space-between row>
                  <div class="searched-variant-title" slot="header">
                    <strong v-if="item.variants.length > 1">{{v.title}}</strong> <span class="sku" v-if="v.sku"> {{v.sku}}</span><span class="sku" v-else> <i>(No sku)</i></span>
                  </div>
                  <span v-if="!variantAdded(v.id)" class="add" @click="() => { addVariant(i, j) }">Add</span>
                  <span v-else class="added">Added</span>
                </v-layout>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-layout align-center justify-center row>
            <div class="text-xs-center">
              <v-btn v-if="previousPageInfo" fab small @click="() => { searchProducts(false) }">
                <v-icon dark>arrow_back</v-icon>
              </v-btn>
              <v-btn v-else disabled fab small>
                <v-icon dark>arrow_back</v-icon>
              </v-btn>
              <v-btn v-if="nextPageInfo" fab small @click="() => { searchProducts(true) }">
                <v-icon dark>arrow_forward</v-icon>
              </v-btn>
              <v-btn v-else disabled fab small>
                <v-icon dark>arrow_forward</v-icon>
              </v-btn>
            </div>
          </v-layout>
        </v-card>

        <div class="added-products" style="width: 70%;">
          <h4 class="headline">Search and add products or variants to this group. When you’re done, click the <strong>Save</strong> button.</h4>

          <div class="added-products-container">
            <v-layout class="variant" v-for="(v,i) in addedVariants" align-center justify-space-between row>
              <div class="added-variant-title" slot="header">
                <a v-if="v.variant_link && v.variant_link !== null" target="_blank" :href="`${v.variant_link}`"> <strong>{{v.shopify_product_title}}</strong> {{ v.shopify_variant_title }}</a>
                <span> | </span>
                <a v-if="v.inventory_link && v.inventory_link !== null" target="_blank" :href="`${v.inventory_link}`">(view inventory history)</a>
              </div>
              <span class="remove" @click="() => { removeVariant(v.shopify_variant_id) }">Remove</span>
            </v-layout>
          </div>
        </div>

      </v-layout>
      <div>
        <br />
        <br />
        <br />
      </div>
    </section>

    <v-layout v-if="deleteDialogEnabled" row justify-center>
      <v-dialog v-model="deleteDialogEnabled" persistent max-width="390">
        <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>
        <v-card>
          <v-card-title class="headline">Are you sure about removing this group?</v-card-title>
          <v-card-text>This action can not be reverted.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click.native="deleteDialogEnabled = false; ">No</v-btn>
            <v-btn color="green darken-1" flat @click.native="deleteDialogEnabled = false; deleteGroup()">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout v-if="disableModeEnabled" row justify-center>
      <v-dialog v-model="disableModeEnabled" persistent max-width="390">
        <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>
        <v-card>
          <v-card-title class="headline">Are you sure?</v-card-title>
          <v-card-text>
            All the groups will be deleted upon disabled. This action cannot be recovered.<br>
            <br>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="disableModeEnabled = false; disableManualgroup()">Permanently Delete</v-btn>
            <v-btn color="green darken-1" flat @click.native="disableModeEnabled = false; ">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout v-if="duplicateEnabled" row justify-center>
      <v-dialog v-model="duplicateEnabled" persistent max-width="500">
        <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>
        <v-card>
          <v-card-title class="headline">Duplicate this bundle?</v-card-title>
          <v-card-text><p>Provide a name for your new bundle</p>
            <v-text-field
                    label="Bundle Name"
                    v-model="duplicateGroupName"
                    placeholder="Enter a Bundle Name (for example: Base T-Shirt White)"
                    single-line
                    solo
            ></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click.native="duplicateEnabled = false; ">Cancel</v-btn>
            <v-btn color="green darken-1" flat @click.native="duplicateEnabled = false; duplicateGroup()" :disabled="!duplicateGroupName">Duplicate</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout v-if="savingAlert" row justify-center>
      <v-dialog v-model="savingAlert" persistent max-width="390">
        <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>
        <v-card>
          <v-card-title class="headline">Can not save the group</v-card-title>
          <v-card-text>
            <ul>
              <li v-if="group_name == ''">Group name is empty</li>
              <li v-else> {{ savingAlertMsg }}</li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click.native="savingAlert = false;">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

  </div>
</template>

<script>
import axios from 'axios';
import {globalStore} from '../main.js'
import _debounce from 'lodash/debounce'

export default {
  computed: {
    count () {
      return this.$store.state.count
    },
    loading () {
      this.checkStatus
      this.checkInventoryLevels
      return this.checkStatus || this.checkInventoryLevels
    }
  },
  created: function () {

  },
  data () {
    return {
      shop: this.$store.state.shop,
      pagination: {
        sortBy: 'name'
      },
      sku_groups: [],
      savingAlert: false,
      manualgroup: false,
      scanning: false,
      checkStatus: true,
      checkInventoryLevels: true,
      mode: 'groups-listing',
      changingMode: false,
      errored: false,
      groupViewEditUrl: '',
      checkStatusInterval: null,
      pKeyword: '',
      previousPageInfo: null,
      nextPageInfo: null,
      searching: false,
      current_group_id: 0,
      group_id_to_be_deleted: 0,
      group_name: '',
      searchedProducts: null,
      location: null,
      loadingLocation: true,
      allLocations: [],
      inventoryLevels: [],
      addedVariants: [],
      savingGroup: false,
      deleteDialogEnabled: false,
      disableModeEnabled: false,
      duplicateEnabled: false,
      duplicateGroupName: '',
      domain: null,
      search: '',
      headers: [
        {
          text: 'Group Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Actions', align: 'right', value: 'gid', sortable: false }
      ],
      groupHeaders: [
        {
          text: 'Product / Variant',
          align: 'left',
          sortable: true,
          value: 'title'
        },
        { text: 'SKU', align: 'left', value: 'sku', sortable: false }
      ],
    }
  },
  filters: {
    currencydecimal (value) {
      return value.toFixed(2)
    }
  },
  watch: {
    pKeyword: function() {
      this.debounceSearchProducts(true,true)
    }
  },
  mounted () {

    axios.defaults.headers.common['Authorization'] =  'Bearer ' + this.$store.getters.code

    this.checkManualgroupStatus()
    this.doCheckInventoryLevels()

  },
  methods: {

    doCheckInventoryLevels () {
      if (globalStore.inventoryLevels != null) {
        this.inventoryLevels = globalStore.inventoryLevels
        this.checkInventoryLevels = false
      } else {
        let check_inventory_url = 'https://' + this.$store.getters.engine + '/api/location/search'

        this.checkInventoryLevels = true

        this.inventoryLevels = []
        let ILVs = this.inventoryLevels
        axios
          .get(check_inventory_url)
          .then(response => {
            response.data.body.data.locations.edges.forEach(function(e){
              e.node.inventoryLevels.edges.forEach(function(edge){
                let inventoryGID = edge.node.id.split('?')[0].split('/')
                ILVs.push(inventoryGID[inventoryGID.length-1])
              })
            })
            globalStore.inventoryLevels = ILVs
          })
          .catch(error => {
            this.errored = true
            console.log(error)
          })
          .finally(() => {
            this.checkInventoryLevels = false
          })
      }
    },

    initNewGroup () {
      this.pKeyword = ''
      this.searchPageIndex = 1
      this.searchNext = false
      this.searchPrev = false
      this.current_group_id = 0
      this.group_name = ''
      this.addedVariants = []
    },

    searchProducts (next = true, refresh = false) {
      let url
      if (refresh) {
        this.previousPageInfo = null
        this.nextPageInfo = null
      }
      if (next) {
        url = `https://${this.$store.getters.engine}/api/products/search?title=${encodeURIComponent(this.pKeyword)}&limit=5&next_page_info=${encodeURIComponent(this.nextPageInfo || '')}`
      } else {
        url = `https://${this.$store.getters.engine}/api/products/search?title=${encodeURIComponent(this.pKeyword)}&limit=5&previous_page_info=${encodeURIComponent(this.previousPageInfo || '')}`
      }

      this.searchedProducts = null
      this.searching = true

      axios
        .get(url)
        .then(response => {
          this.searchedProducts = response.data.products
          this.previousPageInfo = (response.data.has_previous_page ? response.data.previous_page_info : null)
          this.nextPageInfo = (response.data.has_next_page ? response.data.next_page_info : null)
        })
        .catch(error => {
        })
        .finally(() => {this.searching = false})
    },

    addVariant (i, j) {
      this.addedVariants.push(
        {
          "shopify_product_id": this.searchedProducts[i].id,
          "shopify_product_title": this.searchedProducts[i].title,
          "shopify_variant_id": this.searchedProducts[i].variants[j].id,
          "shopify_variant_title": this.searchedProducts[i].variants[j].title,
          "inventory_item_id": this.searchedProducts[i].variants[j].inventory_item_id,
          "shopify_product_admin_graphql_api_id": this.searchedProducts[i].admin_graphql_api_id,
          "shopify_variant_admin_graphql_api_id": this.searchedProducts[i].variants[j].admin_graphql_api_id,
          "variant_link": `https://${this.$store.state.shop}/admin/products/${this.searchedProducts[i].id}/variants/${this.searchedProducts[i].variants[j].id}/`,
          "inventory_link": `https://${this.$store.state.shop}/admin/products/inventory/${this.searchedProducts[i].variants[j].inventory_item_id}/inventory_history`,
        }
      )
    },

    variantAdded (i) {
      for (let j=0;j<this.addedVariants.length;j++) {
        if (this.addedVariants[j].shopify_variant_id == i) {
          return true
        }
      }
      return false
    },

    removeVariant (i) {
      for (let j=0;j<this.addedVariants.length;j++) {
        if (this.addedVariants[j].shopify_variant_id == i) {
          this.addedVariants.splice(j, 1)
          break
        }
      }
    },

    saveGroup() {
      if (this.savingGroup) {
        return
      }
      if (this.group_name == '') {
        this.savingAlert = true
        return
      }
      if (this.current_group_id == 0) {
        let url = `https://${this.$store.getters.engine}/api/manualgroup/create`
        this.savingGroup = true
        axios
          .post(url, {
            "group_name": this.group_name,
            "variants": this.addedVariants
          })
          .then(response => {
            if (response.data && response.data.status === "failed") {
              this.savingAlert = true
              this.savingAlertMsg = response.data.message
              this.savingGroup = false
              return
            } else {
              this.mode = 'groups-listing'
              this.savingGroup = false
              this.scanGroups()
            }
          })
          .catch(error => {
          })
          .finally(() => {
          })
      } else {
        let url = `https://${this.$store.getters.engine}/api/manualgroup/update`
        axios
          .post(url, {
            "id": this.current_group_id,
            "group_name": this.group_name,
            "variants": this.addedVariants
          })
          .then(response => {
            if (response.data && response.data.status === "failed") {
              this.savingAlert = true
              this.savingAlertMsg = response.data.message
              this.savingGroup = false
              return
            } else {
              this.mode = 'groups-listing'
              this.savingGroup = false
              this.scanGroups()
            }
          })
          .catch(error => {
          })
          .finally(() => {
          })
      }
    },

    duplicateGroup () {
      if (this.savingGroup) {
        return
      }

      let url = `https://${this.$store.getters.engine}/api/manualgroup/create`
      this.savingGroup = true
      axios
        .post(url, {
          "group_name": this.duplicateGroupName,
          "auto_update_master": this.auto_update_master,
          "variants": this.addedVariants
        })
        .then(response => {
          let id = response.data.id
          url = 'https://' + this.$store.getters.engine + '/api/manualgroup'
          this.scanning = true
          axios
            .get(url)
            .then(response => {
              this.sku_groups = []
              response.data.forEach(g => {
                this.sku_groups.push({
                  value: g.id,
                  name: g.group_name,
                  sku: g.sku,
                  gid: {domain: g.shopify_domain, id: g.id}
                })
              })
              this.editGroup(this.domain, id)
            })
            .catch(error => {
              this.errored = true
            })
            .finally(() => {this.scanning = false})

        })
        .catch(error => {

        })
        .finally(() => {
          this.mode = 'groups-listing'
          this.savingGroup = false
        })
    },

    openDeleteGroupDialog (id) {
      if (id != 0) {
        this.group_id_to_be_deleted = id
        this.deleteDialogEnabled = true
      }
    },

    openDuplicateGroupDialog () {
      this.duplicateGroupName = 'Copy of ' + this.group_name
      this.duplicateEnabled = true
    },

    deleteGroup () {
      if (this.group_id_to_be_deleted != 0) {
        let url = `https://${this.$store.getters.engine}/api/manualgroup/delete`
        axios
          .post(url, {
            "id": this.group_id_to_be_deleted
          })
          .then(response => {
          })
          .catch(error => {
          })
          .finally(() => {
            this.group_id_to_be_deleted = 0
            this.mode = 'groups-listing'
            this.scanGroups()
          })
      }
    },

    disableManualgroup () {
      let url = 'https://' + this.$store.getters.engine + '/api/manualgroup/status'

      this.mode = 'groups-listing'

      axios
        .post(url, {"manualgroup": "disabled"})
        .then(response => {
          this.manualgroup = false
        })
        .catch(error => {

        })
        .finally(() => {

        })
    },

    enableManualgroup () {
      let url = 'https://' + this.$store.getters.engine + '/api/manualgroup/status'

      axios
        .post(url, {manualgroup: 'enabled'})
        .then(response => {
          if (response.data.status == 'success') {
            this.checkStatusInterval = setInterval(() => {
              this.checkManualgroupStatus()
            }, 5000)
          }
        })
        .catch(error => {
        })
        .finally(() => {
        })
    },

    checkManualgroupStatus () {
      this.checkStatus = true
      let url = 'https://' + this.$store.getters.engine + '/api/manualgroup/status'

      axios
        .get(url)
        .then(response => {
          if (this.checkStatusInterval) {
            clearInterval(this.checkStatusInterval)
            this.checkStatusInterval = null
          }
          this.manualgroup = (response.data.manualgroup == 'enabled')
          if (this.manualgroup) {
            this.scanGroups()
          }
        })
        .catch(error => {
        })
        .finally(() => {
          this.checkStatus = false
        })
    },

    scanGroups (page = 1) {

      let url = `https://${this.$store.getters.engine}/api/manualgroup${page ? `?page=${page}` : ''}`

      if (page == 1) {
        this.sku_groups = []
      }

      axios
        .get(url)
        .then(response => {
          if (response.data && response.data.length > 0) {
            response.data.forEach(g => {
              this.sku_groups.push({
                value: g.id,
                name: g.group_name,
                sku: g.sku,
                gid: {domain: g.shopify_domain, id: g.id}
              })
            })
            this.scanGroups(page + 1)
          }
        })
        .catch(error => {
          this.errored = true
        })
        .finally(() => {})
    },

    editGroup (domain, id) {
      if (this.changingMode) {
        return
      }
      this.changingMode = true
      this.pKeyword = ''
      this.searchPageIndex = 1
      this.searchNext = false
      this.searchPrev = false
      this.groupViewEditUrl = ''
      this.current_group_id = id
      this.addedVariants = []

      this.sku_groups.forEach(g => {
        if (g.value == id) {
          this.group_name = g.name
        }
      })


      let url = 'https://' + this.$store.getters.engine + '/api/manualgroup/' + id
      let ILs = this.inventoryLevels

      axios
        .get(url)
        .then(response => {
          let vids = ''
          response.data.forEach(v => {
            vids += (vids == '' ? v.shopify_variant_id : ',' + v.shopify_variant_id)
            this.addedVariants.push(
              {
                "shopify_product_id": v.shopify_product_id,
                "shopify_product_title": v.shopify_product_title,
                "shopify_variant_id": v.shopify_variant_id,
                "shopify_variant_title": v.shopify_variant_title,
                "inventory_item_id": v.inventory_item_id,
                "shopify_product_admin_graphql_api_id": v.shopify_product_admin_graphql_api_id,
                "shopify_variant_admin_graphql_api_id": v.shopify_variant_admin_graphql_api_id,
                "inventory_link": `https://${domain}/admin/products/inventory/${v.inventory_item_id}/inventory_history`,
                "variant_link": `https://${domain}/admin/products/${v.shopify_product_id}/variants/${v.shopify_variant_id}/`
              }
            )
          })

          if (ILs.length <= -1) {
            this.groupViewEditUrl = `https://${domain}/admin/bulk?resource_name=ProductVariant&edit=inventory_quantity_adjustment,price&show=full_title,title,sku&ids=${vids}`
          } else {
            let inventoryLVs = ''
            ILs.forEach(function(lv) {
              inventoryLVs += ',inventory_levels.' + lv + '.available_adjustment'
            })
            this.groupViewEditUrl = `https://${domain}/admin/bulk?resource_name=ProductVariant&edit=price${inventoryLVs}&show=full_title,title,sku&ids=${vids}`
          }
        })
        .catch(error => {
        })
        .finally(() => {
          this.mode = 'group-creating'
          this.changingMode = false
          this.searchProducts(true, true)
        })
    },

    closeGroupView() {
      this.mode = 'groups-listing'
      this.scanGroups()
    },

    openLink(url) {
      window.open(url)
    },

    debounceSearchProducts: _debounce(function(next = true, refresh = false) {
      this.searchProducts(next,refresh)
    }, 500)
  }

}
</script>
